import { ItemDocumentFinderThemeSizeConfig } from './types';

const large: ItemDocumentFinderThemeSizeConfig = {
  itemDocumentFinder: {},
};

export default large;
